export enum ReviewType {
  boondock = 'boondock',
  listing = 'listing',
  poi = 'poi',
  guest = 'guest',
}
